import React from 'react';

export default function VideoPlayIcon({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
    >
      <defs>
        <filter id="Ellipse_94" width="52" height="52" x="0" y="0" filterUnits="userSpaceOnUse">
          <feOffset></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.518"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter id="Polygon_5" width="31" height="34" x="12" y="9" filterUnits="userSpaceOnUse">
          <feOffset></feOffset>
          <feGaussianBlur result="blur-2" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.694"></feFlood>
          <feComposite in2="blur-2" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="Group 86">
        <g filter="url(#Ellipse_94)" transform="translate(-1268 -86) translate(1268 86)">
          <g
            fill="none"
            stroke="#f5ff00"
            strokeWidth="2"
            data-name="Ellipse 94"
            transform="translate(9 9)"
          >
            <circle cx="17" cy="17" r="17" stroke="none"></circle>
            <circle cx="17" cy="17" r="16"></circle>
          </g>
        </g>
        <g filter="url(#Polygon_5)" transform="translate(-1268 -86) translate(1268 86)">
          <g fill="none" strokeLinecap="round" strokeLinejoin="round" data-name="Polygon 5">
            <path d="M8 0l8 13H0z" transform="rotate(90 8 26)"></path>
            <path
              fill="#f5ff00"
              d="M8 3.816L3.58 11h8.84L8 3.816M8 0l8 13H0L8 0z"
              transform="rotate(90 8 26)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
